/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IConvexSiloWrapperFactory,
  IConvexSiloWrapperFactoryInterface,
} from "../IConvexSiloWrapperFactory";

const _abi = [
  {
    inputs: [],
    name: "convexSiloWrapperFactoryPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_poolId",
        type: "uint256",
      },
    ],
    name: "createConvexSiloWrapper",
    outputs: [
      {
        internalType: "address",
        name: "wrapper",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_poolId",
        type: "uint256",
      },
    ],
    name: "deployedWrappers",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wrapper",
        type: "address",
      },
    ],
    name: "isWrapper",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IConvexSiloWrapperFactory__factory {
  static readonly abi = _abi;
  static createInterface(): IConvexSiloWrapperFactoryInterface {
    return new utils.Interface(_abi) as IConvexSiloWrapperFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IConvexSiloWrapperFactory {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as IConvexSiloWrapperFactory;
  }
}
